import React, { useEffect, useState } from "react";
import { fetchAllAlumni } from "../components/apifa";

// Function to fetch all alumni


const ProfileHighlight = () => {
  const [alumni, setAlumni] = useState([]);
  const [selectedAlum, setSelectedAlum] = useState(null); // State for selected alumni for modal
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state

  useEffect(() => {
    const getAlumniData = async () => {
      try {
        const data = await fetchAllAlumni();
        console.log(data);
        setAlumni(data);  // Set alumni data
      } catch (error) {
        console.error("Error fetching alumni:", error);
      }
    };

    getAlumniData(); // Fetch alumni data on mount
  }, []);

  const handleCardClick = (alum) => {
    setSelectedAlum(alum);  // Set selected alum for modal
    setIsModalOpen(true); // Open modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close modal
    setSelectedAlum(null); // Clear selected alum
  };

  return (
    <section className="w-full py-16 bg-white text-[#f7c512ad]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold">Meet Our Alumni</h2>
        </div>

        {alumni.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {alumni.slice(0, 3).map((alumn) => (
              <div
                key={alumn.id}
                onClick={() => handleCardClick(alumn)} // Trigger modal on click
                className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl border border-transparent hover:border-blue-600 transition-all duration-300 group cursor-pointer"
              >
                {alumn.profile_image? (
                  <img
                    src={alumn.profile_image}
                    alt={`Profile picture of ${alumn.name}`}
                    className="w-full h-48 object-cover rounded-t-lg"
                  />
                ) : (
                  <div className="w-full h-48 bg-gray-700 rounded-t-lg flex items-center justify-center">
                    <span className="text-gray-400">No Image Available</span>
                  </div>
                )}
                <div className="pt-4 text-center">
                  <h3 className="text-xl font-semibold">{alumn.name}</h3>
                  <span className="text-sm">
                    {alumn.program}, Class of {alumn.batch}
                  </span>
                  {alumn.slogan && (
                    <p className="text-gray-400 italic">{alumn.slogan}</p>
                  )}
               <div className="flex flex-wrap space-x-2 mt-4">
  {alumn.tags.split(",").map((tag, tagIndex) => (
    <span
      key={tagIndex}
      className="bg-blue-200 text-blue-800 text-xs font-semibold px-2 py-1 rounded mb-2"
    >
      {tag.trim()}  {/* Trim spaces if any */}
    </span>
  ))}
</div>

                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-400">
            <p>No alumni profiles available at this time. Please check back later!</p>
          </div>
        )}

        <div className="text-center mt-12">
          <a
            href="/alumni/login"
            className="border border-green-500 hover:bg-green-500 text-black py-3 px-6 transition-all duration-300"
          >
            View All Alumni
          </a>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && selectedAlum && (
  <div className="fixed inset-0 flex justify-center items-center bg-gray-700 bg-opacity-75 z-50">
    <div className="bg-gray-800  p-6 rounded-lg w-11/12 max-w-4xl relative mt-20"> {/* Added mt-20 for vertical spacing */}
      {/* Close Button */}
      <button
        onClick={handleCloseModal}
        className="absolute top-2 right-2 text-2xl font-bold text-gray-600"
      >
        &times;
      </button>

      {/* Modal Content */}
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        {/* Profile Image */}
        <div className="w-40 h-40 lg:w-48 lg:h-48 mb-4 lg:mb-0">
          <img
            src={selectedAlum.profile_image || "https://via.placeholder.com/150"}
            alt={`Profile picture of ${selectedAlum.name}`}
            className="w-full h-full object-cover rounded-full"
          />
        </div>

        {/* Description and Info */}
        <div className="lg:ml-6">
        <div className="mb-4">
            <p><strong className="text-lime-300">Program:</strong> {selectedAlum.program}</p>
            <p><strong className="text-lime-300">Batch:</strong> {selectedAlum.batch}</p>
          </div>
          <h3 className="text-2xl font-semibold mb-2 text-lime-300">{selectedAlum.name}</h3>
          <p className="text-lg mb-4">{selectedAlum.description || "No description available"}</p>

          {/* Program and Batch */}
          
        </div>
      </div>
    </div>
  </div>
)}


    </section>
  );
};

export default ProfileHighlight;
